// import Axios from '../index'
import { authUrl as baseUrl, gaiaKey, requestJson } from './config'
import { handleResponse } from './utils'
import { myAxios } from '../utils'
const checkTokenUrl = `${baseUrl}/check`
// console.log(await requestJson(), 999999)

/*
* 效验token的有效性
* todo token效验失败，直接调用登出方法。登出方法由航道提供
*  */
export const checkToken = async () => {
  return myAxios.post(checkTokenUrl, await requestJson(), {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
export const userInfoByToken = async () => {
  return myAxios.post(checkTokenUrl, { ...await requestJson() }, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
